export const USE_PAGINATION_API = true
export const PAGE_IMAGE = "/images/headers/khub_organization.png"
export const STATE_KEY = 'organizations'
export const SORT_OPTIONS = ['date', 'name']
